import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translateText } from '../services/translationService';

export default function Mag() {
  const [activeCategory, setActiveCategory] = useState('all');
  const { language } = useLanguage();
  const [translatedContent, setTranslatedContent] = useState({});
  const [translating, setTranslating] = useState(false);
  const [expandedArticle, setExpandedArticle] = useState(null);

  // Contenu original en anglais
  const originalContent = {
    hero: {
      title: "The Magazine",
      subtitle: "Discover the D4U Naturally universe: beauty tips, news and inspiration"
    },
    categories: {
      all: "All Articles",
      beauty: "Beauty & Care",
      sustainability: "Sustainability",
      tutorials: "Tutorials",
      culture: "Culture"
    },
    newsletter: {
      title: "Don't Miss Any Article",
      description: "Subscribe to our newsletter to receive our latest articles and beauty tips.",
      placeholder: "Your email",
      button: "Subscribe"
    },
    article: {
      readMore: "Read more",
      readLess: "Read less"
    }
  };

  // Articles complets en anglais
  const originalArticles = [
    {
      id: 1,
      title: "The Golden Secret: Unlocking the Benefits of Argan Oil on Your Skin",
      excerpt: "Discover how pure Argan oil can transform your beauty routine thanks to its unique properties...",
      fullContent: `
        <div class="article-content">
          <div class="article-header">
            <h2 class="article-title">The Golden Secret: Unlocking the Benefits of Argan Oil on Your Skin</h2>
            <div class="article-meta">
              <span class="reading-time">📖 5 min read</span>
              <span class="publish-date">📅 January 15, 2024</span>
            </div>
          </div>

          <div class="article-intro">
            <p class="lead">Pure Argan Oil is often called <em>'liquid gold'</em>—and for good reason. For centuries, this precious oil has been the cornerstone of traditional Moroccan beauty.</p>
          </div>

          <div class="content-section">
            <h3>🌿 Hydrate and Restore: The Power of Essential Fatty Acids</h3>
            <p>Argan oil is rich in <strong>Vitamin E</strong> and essential fatty acids, making it an exceptional natural moisturizer. It penetrates deeply into the skin without leaving a greasy residue, providing long-lasting hydration for both the face and body.</p>
            <div class="benefit-card">
              <h4>💧 Key Benefits:</h4>
              <ul>
                <li>Deep hydration without greasiness</li>
                <li>Strengthens skin barrier</li>
                <li>Suitable for all skin types</li>
              </ul>
            </div>
          </div>

          <div class="content-section">
            <h3>⏰ Fight the Clock: Anti-Aging and Elasticity</h3>
            <p>One of Argan oil's most celebrated benefits is its ability to combat the signs of aging. The oil's high antioxidant content helps neutralize free radicals that contribute to premature aging.</p>
            <blockquote>
              "Regular application promotes skin elasticity and firmness, helping to visibly reduce fine lines."
            </blockquote>
          </div>

          <div class="content-section">
            <h3>🌱 Soothe and Calm: Repairing Sensitive Skin</h3>
            <p>Argan oil contains natural anti-inflammatory compounds that make it ideal for sensitive skin. It helps repair and calm damaged skin while restoring its natural balance.</p>
          </div>

          <div class="brand-section">
            <h3>✨ The D4U Naturally Difference</h3>
            <p>Our commitment goes beyond just the oil. We honor our <strong>Moroccan Heritage</strong> through:</p>
            <div class="features-grid">
              <div class="feature-item">
                <span class="feature-icon">🌿</span>
                <span>100% Natural Ingredients</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">🌍</span>
                <span>Sustainably Sourced</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">🎯</span>
                <span>Traditional Wisdom</span>
              </div>
            </div>
          </div>
        </div>
      `,
      category: "beauty",
      readTime: "5 min",
      date: "15 Jan 2024",
      image: "/images/argan-oil-benefits.jpg"
    },
    {
      id: 2,
      title: "Beyond Beauty: Our Sustainable Production Process",
      excerpt: "Learn how D4U Naturally produces its pure Argan products while respecting the environment...",
      fullContent: `
        <div class="article-content">
          <div class="article-header">
            <h2 class="article-title">Beyond Beauty: Our Sustainable Production Process</h2>
            <div class="article-meta">
              <span class="reading-time">📖 7 min read</span>
              <span class="publish-date">📅 January 12, 2024</span>
            </div>
          </div>

          <div class="article-intro">
            <p class="lead">At D4U Naturally, we believe that true beauty shouldn't come at the expense of our planet or the people who help create our products.</p>
          </div>

          <div class="content-section">
            <h3>🌳 Respecting the Arganeraie Biosphere</h3>
            <p>The Argan tree is a precious resource, and its preservation is our priority. We source our Argan oil exclusively from the protected region of the Arganeraie.</p>
            <div class="highlight-box">
              <h4>🏆 UNESCO Protected</h4>
              <p>The Arganeraie Biosphere Reserve is designated as a protected global ecosystem, ensuring sustainable practices.</p>
            </div>
          </div>

          <div class="content-section">
            <h3>🤝 Supporting Local Communities</h3>
            <p>Our production process is deeply rooted in social responsibility. We work closely with local cooperatives run by Berber women.</p>
            <div class="impact-stats">
              <div class="stat">
                <span class="stat-number">100%</span>
                <span class="stat-label">Fair Wages</span>
              </div>
              <div class="stat">
                <span class="stat-number">0</span>
                <span class="stat-label">Animal Testing</span>
              </div>
              <div class="stat">
                <span class="stat-number">♻️</span>
                <span class="stat-label">Zero Waste Goal</span>
              </div>
            </div>
          </div>

          <div class="content-section">
            <h3>🔬 Pure and Ethical Formulations</h3>
            <p>Our commitment to purity means we strictly avoid harmful chemicals and prioritize environmentally sound processes.</p>
            <div class="ingredient-list">
              <h4>✅ What's Inside:</h4>
              <ul>
                <li>Pure Argan Oil</li>
                <li>Natural Antioxidants</li>
                <li>Essential Vitamins</li>
              </ul>
              <h4>❌ What's Not:</h4>
              <ul>
                <li>Parabens</li>
                <li>Sulfates</li>
                <li>Synthetic Fragrances</li>
              </ul>
            </div>
          </div>
        </div>
      `,
      category: "sustainability",
      readTime: "7 min",
      date: "12 Jan 2024",
      image: "/images/sustainable-production.jpg"
    },
    {
      id: 3,
      title: "The Perfect Morning and Evening Facial Care Routine for Radiant Skin",
      excerpt: "Master the perfect facial care routine with D4U Naturally's pure Argan-infused products...",
      fullContent: `
        <div class="article-content">
          <div class="article-header">
            <h2 class="article-title">The Perfect Morning and Evening Facial Care Routine</h2>
            <div class="article-meta">
              <span class="reading-time">📖 8 min read</span>
              <span class="publish-date">📅 January 10, 2024</span>
            </div>
          </div>

          <div class="article-intro">
            <p class="lead">Achieving radiant skin is all about consistency and using the right natural products. A proper routine is an investment in your skin's long-term health.</p>
          </div>

          <div class="routine-section morning-routine">
            <h3>🌅 Morning Ritual: Protection and Hydration</h3>
            <div class="routine-steps">
              <div class="step">
                <span class="step-number">1</span>
                <div class="step-content">
                  <h4>Gentle Cleansing</h4>
                  <p>Start by washing your face to remove overnight toxins. Use a mild, sulfate-free cleanser.</p>
                  <span class="step-tip">💡 Tip: Use lukewarm water to avoid stripping natural oils</span>
                </div>
              </div>
              <div class="step">
                <span class="step-number">2</span>
                <div class="step-content">
                  <h4>Serum Application</h4>
                  <p>Apply targeted treatments like our Under Eye Serum to reduce puffiness.</p>
                </div>
              </div>
              <div class="step">
                <span class="step-number">3</span>
                <div class="step-content">
                  <h4>Moisturize and Protect</h4>
                  <p>Lock in hydration with Pure Argan Oil or a lightweight day cream.</p>
                </div>
              </div>
            </div>
          </div>

          <div class="routine-section evening-routine">
            <h3>🌙 Evening Ritual: Cleanse, Repair, and Renew</h3>
            <div class="routine-steps">
              <div class="step">
                <span class="step-number">1</span>
                <div class="step-content">
                  <h4>Deep Double Cleanse</h4>
                  <p>Remove makeup, pollution, and dirt with our Black Soap or gentle cleanser.</p>
                  <span class="step-tip">🚫 Non-negotiable: Never sleep with makeup on</span>
                </div>
              </div>
              <div class="step">
                <span class="step-number">2</span>
                <div class="step-content">
                  <h4>Treatment & Regeneration</h4>
                  <p>Apply Pure Argan Oil - its antioxidants work overnight to repair damage.</p>
                </div>
              </div>
              <div class="step">
                <span class="step-number">3</span>
                <div class="step-content">
                  <h4>Lock It In</h4>
                  <p>Finish with a richer night cream for extra nourishment.</p>
                </div>
              </div>
            </div>
          </div>

          <div class="product-recommendations">
            <h3>💫 Recommended Products</h3>
            <div class="products-grid">
              <div class="product-item">
                <strong>Pure Argan Oil</strong>
                <span>For deep hydration</span>
              </div>
              <div class="product-item">
                <strong>Under Eye Serum</strong>
                <span>For delicate skin</span>
              </div>
              <div class="product-item">
                <strong>Black Soap</strong>
                <span>For deep cleansing</span>
              </div>
            </div>
          </div>
        </div>
      `,
      category: "tutorials",
      readTime: "8 min",
      date: "10 Jan 2024",
      image: "/images/facial-care-routine.jpg"
    },
    {
      id: 4,
      title: "The Golden Roots: The Story of the Moroccan Argan Tree",
      excerpt: "Dive into the fascinating history of the Argan tree and its millenary virtues...",
      fullContent: `
        <div class="article-content">
          <div class="article-header">
            <h2 class="article-title">The Golden Roots: The Story of the Moroccan Argan Tree</h2>
            <div class="article-meta">
              <span class="reading-time">📖 6 min read</span>
              <span class="publish-date">📅 January 8, 2024</span>
            </div>
          </div>

          <div class="article-intro">
            <p class="lead">The Argan tree (Argania spinosa) is much more than just a source of oil; it is a symbol of Moroccan heritage and resilience.</p>
          </div>

          <div class="content-section">
            <h3>🌴 A Unique and Protected Ecosystem</h3>
            <p>The Argan tree is perfectly adapted to the harsh, dry climate of the Moroccan desert. This rarity led UNESCO to designate the Arganeraie as a protected global ecosystem.</p>
            <div class="eco-facts">
              <div class="eco-fact">
                <span class="fact-icon">📍</span>
                <div class="fact-content">
                  <strong>Location</strong>
                  <span>Semi-arid southwest Morocco</span>
                </div>
              </div>
              <div class="eco-fact">
                <span class="fact-icon">🛡️</span>
                <div class="fact-content">
                  <strong>Protection</strong>
                  <span>UNESCO Biosphere Reserve</span>
                </div>
              </div>
              <div class="eco-fact">
                <span class="fact-icon">🌡️</span>
                <div class="fact-content">
                  <strong>Climate</strong>
                  <span>Adapted to harsh conditions</span>
                </div>
              </div>
            </div>
          </div>

          <div class="content-section">
            <h3>👑 Millenary Virtues and Traditional Wisdom</h3>
            <p>For centuries, local Berber women have been the guardians of traditional knowledge surrounding the Argan tree.</p>
            <div class="tradition-section">
              <h4>🧴 Traditional Extraction Process:</h4>
              <ol>
                <li>Manual harvesting of Argan fruits</li>
                <li>Sun-drying and peeling</li>
                <li>Stone grinding of kernels</li>
                <li>Cold-press extraction</li>
                <li>Natural filtration</li>
              </ol>
            </div>
          </div>

          <div class="content-section">
            <h3>🔬 From Tradition to Modern Science</h3>
            <p>While tradition remains the heart of our process, D4U Naturally blends this wisdom with modern science to ensure visible, lasting results.</p>
            <blockquote class="heritage-quote">
              "Every product carries the essence of authentic Moroccan lineage, combining ancient wisdom with contemporary research."
            </blockquote>
          </div>

          <div class="heritage-values">
            <h3>💎 Our Heritage Values</h3>
            <div class="values-grid">
              <div class="value-item">
                <span class="value-icon">🌿</span>
                <h4>Authenticity</h4>
                <p>True to traditional methods</p>
              </div>
              <div class="value-item">
                <span class="value-icon">⚡</span>
                <h4>Innovation</h4>
                <p>Modern scientific approach</p>
              </div>
              <div class="value-item">
                <span class="value-icon">🤝</span>
                <h4>Community</h4>
                <p>Supporting local cooperatives</p>
              </div>
            </div>
          </div>
        </div>
      `,
      category: "culture",
      readTime: "6 min",
      date: "8 Jan 2024",
      image: "/images/moroccan-argan-tree.jpg"
    }
  ];

  // Traduction du contenu
  useEffect(() => {
    const translateContent = async () => {
      if (language === 'en') {
        setTranslatedContent({
          ...originalContent,
          articles: originalArticles
        });
        return;
      }

      try {
        setTranslating(true);
        console.log(`🌐 Translating Magazine: en → ${language}`);

        const translated = { ...originalContent };
        const translatedArticles = [...originalArticles];

        // Traduire le contenu principal
        for (const [sectionKey, sectionValue] of Object.entries(originalContent)) {
          if (typeof sectionValue === 'string') {
            translated[sectionKey] = await translateText(sectionValue, language, 'en');
          } else if (typeof sectionValue === 'object') {
            for (const [key, value] of Object.entries(sectionValue)) {
              if (typeof value === 'string') {
                translated[sectionKey][key] = await translateText(value, language, 'en');
              }
            }
          }
        }

        // Traduire les articles (titres et extraits seulement pour les performances)
        for (let i = 0; i < translatedArticles.length; i++) {
          try {
            const [translatedTitle, translatedExcerpt] = await Promise.all([
              translateText(translatedArticles[i].title, language, 'en'),
              translateText(translatedArticles[i].excerpt, language, 'en')
            ]);
            
            translatedArticles[i] = {
              ...translatedArticles[i],
              title: translatedTitle,
              excerpt: translatedExcerpt
            };
          } catch (error) {
            console.error(`Error translating article ${translatedArticles[i].id}:`, error);
          }
        }

        setTranslatedContent({
          ...translated,
          articles: translatedArticles
        });

        console.log('✅ Magazine translated successfully');
      } catch (error) {
        console.error('💥 Translation error Magazine:', error);
        setTranslatedContent({
          ...originalContent,
          articles: originalArticles
        });
      } finally {
        setTranslating(false);
      }
    };

    translateContent();
  }, [language]);

  // Utiliser le contenu traduit ou original
  const content = translatedContent.hero ? translatedContent : originalContent;
  const articles = content.articles || originalArticles;

  const categories = [
    { id: 'all', name: content.categories?.all || "All Articles" },
    { id: 'beauty', name: content.categories?.beauty || "Beauty & Care" },
    { id: 'sustainability', name: content.categories?.sustainability || "Sustainability" },
    { id: 'tutorials', name: content.categories?.tutorials || "Tutorials" },
    { id: 'culture', name: content.categories?.culture || "Culture" }
  ];

  const filteredArticles = activeCategory === 'all' 
    ? articles 
    : articles.filter(article => article.category === activeCategory);

  // Gestion de l'expansion des articles
  const toggleArticle = (articleId) => {
    setExpandedArticle(expandedArticle === articleId ? null : articleId);
  };

  // Gestion de la newsletter
  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    alert(language === 'fr' ? `Merci pour votre inscription avec: ${email}` :
          language === 'ar' ? `شكرًا لك على الاشتراك باستخدام: ${email}` :
          `Thank you for subscribing with: ${email}`);
    e.target.reset();
  };

  // Obtenir le nom de la catégorie traduite
  const getTranslatedCategory = (category) => {
    return content.categories?.[category] || 
           (category === 'beauty' && 'Beauty & Care') ||
           (category === 'sustainability' && 'Sustainability') ||
           (category === 'tutorials' && 'Tutorials') ||
           (category === 'culture' && 'Culture') ||
           category;
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Overlay de traduction */}
      {translating && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 flex items-center space-x-4">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#d0b125]"></div>
            <p className="text-[#2f2a1e] font-light">
              {language === 'fr' ? 'Mise à jour des traductions...' : 
               language === 'ar' ? 'جاري تحديث الترجمات...' : 
               'Updating translations...'}
            </p>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#2f2a1e] to-[#1a1712] text-white py-24">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-5xl font-serif font-light mb-6 tracking-tight">
            {content.hero?.title || "The Magazine"}
          </h1>
          <p className="text-xl text-amber-100/90 font-light max-w-2xl mx-auto leading-relaxed">
            {content.hero?.subtitle || "Discover the D4U Naturally universe: beauty tips, news and inspiration"}
          </p>
        </div>
      </section>

      {/* Categories */}
      <section className="py-8 border-b border-amber-100 bg-amber-50/30">
        <div className="max-w-4xl mx-auto px-6">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map(category => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`px-6 py-3 rounded-full border-2 transition-all duration-300 font-medium text-sm tracking-wide ${
                  activeCategory === category.id
                    ? 'bg-[#d0b125] text-white border-[#d0b125] shadow-lg transform scale-105'
                    : 'bg-white text-gray-700 border-amber-200 hover:border-[#d0b125] hover:text-[#d0b125] hover:shadow-md'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-16 bg-gradient-to-b from-amber-50/20 to-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="space-y-16">
            {filteredArticles.map(article => (
              <article 
                key={article.id} 
                className="bg-white rounded-2xl shadow-sm hover:shadow-2xl transition-all duration-500 overflow-hidden border border-amber-100"
              >
                {/* Image Header */}
                <div className="h-80 bg-gradient-to-br from-amber-100 to-amber-50 relative overflow-hidden">
                  <img 
                    src={article.image} 
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                    onError={(e) => {
                      e.target.src = "/images/placeholder-article.jpg";
                    }}
                  />
                  <div className="absolute top-6 left-6">
                    <span className="bg-[#d0b125] text-white px-4 py-2 rounded-full text-sm font-medium capitalize shadow-lg">
                      {getTranslatedCategory(article.category)}
                    </span>
                  </div>
                  <div className="absolute bottom-6 left-6 bg-black/70 text-white px-4 py-2 rounded-lg backdrop-blur-sm">
                    <div className="text-sm font-light opacity-90">
                      {article.date} • {article.readTime} {language === 'fr' ? 'de lecture' : language === 'ar' ? 'قراءة' : 'read'}
                    </div>
                  </div>
                </div>
                
                {/* Article Content */}
                <div className="p-8">
                  <h3 className="text-3xl font-serif font-light text-gray-900 mb-4 leading-tight">
                    {article.title}
                  </h3>
                  
                  <p className="text-lg text-gray-600 mb-6 leading-relaxed font-light">
                    {article.excerpt}
                  </p>

                  {/* Contenu complet dépliable */}
                  {expandedArticle === article.id && (
                    <div className="mt-8 pt-8 border-t border-amber-100">
                      <style jsx>{`
                        .article-content {
                          font-family: 'Inter', sans-serif;
                          line-height: 1.7;
                          color: #374151;
                        }
                        .article-header {
                          border-bottom: 2px solid #fbbf24;
                          padding-bottom: 1.5rem;
                          margin-bottom: 2rem;
                        }
                        .article-title {
                          font-family: 'Playfair Display', serif;
                          font-size: 2.5rem;
                          font-weight: 400;
                          color: #1f2937;
                          margin-bottom: 1rem;
                          line-height: 1.2;
                        }
                        .article-meta {
                          display: flex;
                          gap: 1.5rem;
                          font-size: 0.9rem;
                          color: #6b7280;
                        }
                        .article-intro .lead {
                          font-size: 1.25rem;
                          font-weight: 300;
                          color: #4b5563;
                          font-style: italic;
                          border-left: 4px solid #d0b125;
                          padding-left: 1rem;
                          margin: 2rem 0;
                        }
                        .content-section {
                          margin: 2.5rem 0;
                        }
                        .content-section h3 {
                          font-family: 'Playfair Display', serif;
                          font-size: 1.5rem;
                          font-weight: 500;
                          color: #374151;
                          margin-bottom: 1rem;
                          display: flex;
                          align-items: center;
                          gap: 0.5rem;
                        }
                        .content-section p {
                          margin-bottom: 1rem;
                          font-size: 1.1rem;
                          line-height: 1.8;
                        }
                        .benefit-card, .highlight-box {
                          background: linear-gradient(135deg, #fefce8, #fef3c7);
                          border: 1px solid #fde68a;
                          border-radius: 12px;
                          padding: 1.5rem;
                          margin: 1.5rem 0;
                        }
                        .benefit-card h4, .highlight-box h4 {
                          color: #92400e;
                          margin-bottom: 0.75rem;
                          font-weight: 600;
                        }
                        .benefit-card ul, .ingredient-list ul {
                          list-style: none;
                          padding: 0;
                        }
                        .benefit-card li, .ingredient-list li {
                          padding: 0.5rem 0;
                          padding-left: 1.5rem;
                          position: relative;
                        }
                        .benefit-card li:before, .ingredient-list li:before {
                          content: '✓';
                          position: absolute;
                          left: 0;
                          color: #d0b125;
                          font-weight: bold;
                        }
                        .impact-stats {
                          display: grid;
                          grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
                          gap: 1rem;
                          margin: 1.5rem 0;
                        }
                        .stat {
                          text-align: center;
                          padding: 1rem;
                          background: white;
                          border-radius: 8px;
                          border: 1px solid #fde68a;
                        }
                        .stat-number {
                          display: block;
                          font-size: 1.5rem;
                          font-weight: 700;
                          color: #d0b125;
                        }
                        .stat-label {
                          font-size: 0.9rem;
                          color: #6b7280;
                        }
                        blockquote {
                          border-left: 4px solid #d0b125;
                          padding: 1rem 1.5rem;
                          margin: 1.5rem 0;
                          background: #fffbeb;
                          font-style: italic;
                          color: #92400e;
                        }
                        .routine-section {
                          margin: 2.5rem 0;
                          padding: 1.5rem;
                          border-radius: 12px;
                        }
                        .morning-routine {
                          background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
                          border: 1px solid #bae6fd;
                        }
                        .evening-routine {
                          background: linear-gradient(135deg, #faf5ff, #f3e8ff);
                          border: 1px solid #ddd6fe;
                        }
                        .routine-steps {
                          space-y: 1.5rem;
                        }
                        .step {
                          display: flex;
                          gap: 1rem;
                          margin: 1.5rem 0;
                        }
                        .step-number {
                          background: #d0b125;
                          color: white;
                          width: 2rem;
                          height: 2rem;
                          border-radius: 50%;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          font-weight: bold;
                          flex-shrink: 0;
                        }
                        .step-content h4 {
                          color: #374151;
                          margin-bottom: 0.5rem;
                          font-weight: 600;
                        }
                        .step-tip {
                          display: block;
                          font-size: 0.9rem;
                          color: #6b7280;
                          font-style: italic;
                          margin-top: 0.5rem;
                        }
                        .features-grid, .values-grid, .products-grid {
                          display: grid;
                          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                          gap: 1rem;
                          margin: 1.5rem 0;
                        }
                        .feature-item, .value-item, .product-item {
                          text-align: center;
                          padding: 1rem;
                          background: white;
                          border-radius: 8px;
                          border: 1px solid #fde68a;
                        }
                        .feature-icon, .value-icon {
                          font-size: 1.5rem;
                          margin-bottom: 0.5rem;
                          display: block;
                        }
                        .eco-facts {
                          display: grid;
                          gap: 1rem;
                          margin: 1.5rem 0;
                        }
                        .eco-fact {
                          display: flex;
                          align-items: center;
                          gap: 1rem;
                          padding: 1rem;
                          background: white;
                          border-radius: 8px;
                          border: 1px solid #fde68a;
                        }
                        .fact-icon {
                          font-size: 1.25rem;
                        }
                        .fact-content {
                          display: flex;
                          flex-direction: column;
                        }
                        .fact-content strong {
                          color: #374151;
                        }
                        .fact-content span {
                          color: #6b7280;
                          font-size: 0.9rem;
                        }
                        .tradition-section ol {
                          list-style: decimal;
                          padding-left: 1.5rem;
                          margin: 1rem 0;
                        }
                        .tradition-section li {
                          padding: 0.5rem 0;
                          color: #374151;
                        }
                        .heritage-quote {
                          background: linear-gradient(135deg, #fffbeb, #fef3c7);
                          border-color: #f59e0b;
                        }
                      `}</style>
                      <div 
                        className="article-content"
                        dangerouslySetInnerHTML={{ __html: article.fullContent }}
                      />
                    </div>
                  )}
                  
                  <button 
                    onClick={() => toggleArticle(article.id)}
                    className="inline-flex items-center gap-2 bg-gradient-to-r from-[#d0b125] to-amber-500 text-white px-6 py-3 rounded-full hover:from-amber-500 hover:to-amber-600 transition-all duration-300 font-medium shadow-lg hover:shadow-xl mt-6"
                  >
                    {expandedArticle === article.id 
                      ? (content.article?.readLess || "Read less") 
                      : (content.article?.readMore || "Read more")
                    }
                    <svg 
                      className={`w-4 h-4 transition-transform duration-300 ${expandedArticle === article.id ? 'rotate-180' : ''}`} 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                </div>
              </article>
            ))}
          </div>

          {/* Newsletter */}
          <div className="mt-20 bg-gradient-to-br from-amber-50 to-amber-100 rounded-2xl p-10 text-center border border-amber-200 shadow-lg">
            <h3 className="text-3xl font-serif font-light text-gray-900 mb-4">
              {content.newsletter?.title || "Don't Miss Any Article"}
            </h3>
            <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto leading-relaxed">
              {content.newsletter?.description || "Subscribe to our newsletter to receive our latest articles and beauty tips."}
            </p>
            <form onSubmit={handleNewsletterSubmit} className="flex max-w-md mx-auto bg-white rounded-full p-2 shadow-lg border border-amber-200">
              <input
                type="email"
                name="email"
                placeholder={content.newsletter?.placeholder || "Your email"}
                className="flex-1 px-6 py-3 rounded-full focus:outline-none focus:ring-2 focus:ring-[#d0b125]"
                required
              />
              <button 
                type="submit"
                className="bg-gradient-to-r from-[#d0b125] to-amber-500 text-white px-8 py-3 rounded-full hover:from-amber-500 hover:to-amber-600 transition-all duration-300 font-medium shadow-lg"
              >
                {content.newsletter?.button || "Subscribe"}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Debug info */}
      {process.env.NODE_ENV === 'development' && (
        <div className="fixed bottom-4 left-4 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded z-50">
          Language: {language}
        </div>
      )}
    </div>
  );
}